import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { POST_PARTNER_VOUCHER_VALIDATE_API } from "@apis/apiPath";

const usePartnerVoucherApi = () => {
	const Ajax = useAjax();

	// 驗證兌換序號（只讀，不消耗）。params: { code, scene }，scene 1 結帳、2 入會合約
	const postPartnerVoucherValidateApi = useCallback(
		async params => await Ajax.post(POST_PARTNER_VOUCHER_VALIDATE_API, params),
		// eslint-disable-next-line
		[]
	);

	return {
		postPartnerVoucherValidateApi,
	};
};

export default usePartnerVoucherApi;
